export const previewTopicKey = value => typeof value === 'string'
    ? value.trim().replace(/\s+/g, ' ').toLowerCase()
    : '';

// Keep stored order: skip the speaker's name, but a blank or invalid topic
// still means no label.
export const getPreviewTopic = (preview, { uppercase = true } = {}) => {
    if (!Array.isArray(preview?.topics)) return '';

    const speakerName = preview.person?.name;
    const speakerKey = previewTopicKey(speakerName);
    for (const value of preview.topics) {
        if (typeof value !== 'string') return '';
        const topic = value.trim();
        if (!topic) return '';
        if (previewTopicKey(topic) !== speakerKey) return uppercase ? topic.toUpperCase() : topic;
    }
    return '';
};
